import { NotificationProgrammatic as Notification } from 'buefy'
import { ToastProgrammatic as Toast } from 'buefy'

export enum NotificationType {
  SUCCESS = 'is-success',
  DANGER = 'is-danger',
  WARNING = 'is-warning',
  INFO = 'is-info',
  DEFAULT = ''
}

export enum Position {
  TOP = 'is-top',
  TOP_RIGHT = 'is-top-right',
  TOP_LEFT = 'is-top-left',
  BOTTOM_RIGHT = 'is-bottom-right',
  BOTTOM_LEFT = 'is-bottom-left',
  BOTTOM = 'is-bottom'
}

export const showNotification = (
  type: NotificationType = NotificationType.INFO,
  message: string,
  duration: number = 2000,
  position: Position = Position.TOP
) => {
  Notification.open({
    message: message,
    duration: duration,
    type: type,
    position: position,
    pauseOnHover: false,
    hasIcon: true,
    closable: false
  })
}

export const showToast = (
  type: NotificationType = NotificationType.INFO,
  message: string,
  duration: number = 2000,
  position: Position = Position.TOP
) => {
  Toast.open({
    message: message,
    type: type,
    duration: duration,
    position: position
  })
}
